import { SEND_EMAIL, SEND_EMAIL_SUCCESS, SEND_EMAIL_ERROR, SEND_EMAIL_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SendEmail = (state = initialState, action) => {
  switch (action.type) {
    case SEND_EMAIL:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SEND_EMAIL_SUCCESS:
      state = {
        ...state,
        data: null,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SEND_EMAIL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SEND_EMAIL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SendEmail;
